export default "__VITE_ASSET__Ci5ihUfL__"